import { Alert, Button } from "antd";
import { useIntl } from "react-intl";
import IntlMessages from "../../util/IntlMessages";

const NotificationRequestBanner = () => {
   const intl = useIntl();

   if (!("Notification" in window)) {
      //Questo browser non supporta le notifiche
      return null;
   }

   if (Notification.permission !== "default") {
      return null; // No need to show the banner if permission is already granted
   }

   return (
      <Alert
         type="info"
         className="gx-mb-0 gx-p-2 gx-text-center"
         message={
            <div className="gx-text-info">
               <IntlMessages id="common.enable_notifications_p" />
            </div>
         }
         action={
            <Button
               type="default"
               size="small"
               className="gx-mb-0 gx-bg-info gx-text-white gx-border-info"
               onClick={() => {
                  Notification.requestPermission().then((permission) => {
                     window.location.reload(); // Reload to apply changes
                  });
               }}
            >
               {intl.formatMessage({ id: "common.enable_notifications" })}
            </Button>
         }
      />
   );
};

export default NotificationRequestBanner;
